import type { PollResultsResponseMostVotedOption } from './pollResultsResponseMostVotedOption';
import type { PollResultsResponseOptionsItem } from './pollResultsResponseOptionsItem';

/**
 * 투표 결과 정보 (결과 포함)
 */
export interface PollResultsResponse {
  durationMinutes?: number;
  expiresAt?: string;
  isExpired: boolean;
  /**
   * 투표 결과의 선택지 정보
   * @nullable
   */
  mostVotedOption?: PollResultsResponseMostVotedOption;
  /** 투표 선택지 목록 및 결과 (% 포함) */
  options: PollResultsResponseOptionsItem[];
  pollId: string;
  question: string;
  totalVotes: number;
  /** @nullable */
  userVotedOptionId?: string | null;
}
